<!-- Bloque «Dónde está cada precio» (pantalla 4 del mockup). Solo referencia. -->
<div style="background: #fff; border: 1px solid #e5e7eb; border-radius: 14px; padding: 14px; margin: 4px 0 14px; display: flex; flex-direction: column; gap: 12px; max-width: 100%; min-width: 0; box-sizing: border-box; overflow-x: hidden;">

  <!-- Encabezado -->
  <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap;">
    <div style="display: flex; flex-direction: column; gap: 2px; min-width: 0;">
      <span style="font-size: 0.9rem; font-weight: 800; color: #111827;">D&oacute;nde est&aacute; cada precio</span>
      <span style="font-size: 0.72rem; color: #4b5563;">{{ rotulos.subtitulo }}</span>
    </div>
    <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
      <!-- Sale de la tabla A/B/C contra Binance, que con el modelo de distancia no se muestra -->
      <span *ngIf="binanceLeido && resumen.texto && !esDistancia"
        [style.background]="resumen.tono === 'bueno' ? '#ecfdf5' : resumen.tono === 'malo' ? '#fef2f2' : '#f3f4f6'"
        [style.borderColor]="resumen.tono === 'bueno' ? '#a7f3d0' : resumen.tono === 'malo' ? '#fecaca' : '#e5e7eb'"
        [style.color]="resumen.tono === 'bueno' ? '#065f46' : resumen.tono === 'malo' ? '#991b1b' : '#4b5563'"
        style="padding: 3px 10px; border: 1px solid; border-radius: 9999px; font-size: 0.72rem; font-weight: 700;">
        {{ resumen.texto }}
      </span>
      <button type="button" (click)="cargar()" [disabled]="cargando" aria-label="Actualizar precios de Binance ahora"
        [style.opacity]="cargando ? '0.6' : '1'"
        style="display: inline-flex; align-items: center; gap: 4px; background: #fff; border: 1px solid #d1d5db; border-radius: 9999px; padding: 3px 12px; cursor: pointer; color: #1C593D; font-size: 0.72rem; font-weight: 700; white-space: nowrap;">
        &#8635; Actualizar
      </button>
    </div>
  </div>

  <!-- Números -->
  <!-- Modelo de distancia (Oscar, 23/10): solo quedan Binance y el otro sentido como fichas chicas;
       costo, base, rango, gráfico y tabla A/B/C pasan al bloque «Lo que cotiza el motor ahora». -->
  <div [class]="esDistancia ? 'grid grid-cols-1 min-[420px]:grid-cols-2 gap-2' : 'grid grid-cols-1 min-[420px]:grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-2'" style="min-width: 0;">
    <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 10px 12px; min-width: 0;" [class]="esDistancia ? '' : 'min-[420px]:col-span-2 sm:col-span-1'">
      <p style="font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.5px; color: #1d4ed8; font-weight: 700; margin-bottom: 4px;">Binance P2P en vivo</p>
      <ng-container *ngIf="binance; else binanceNoDisponible">
        <div style="display: grid; grid-template-columns: auto 1fr; gap: 2px 8px; align-items: baseline; font-size: 0.78rem;">
          <span [style.fontWeight]="ladoRelevante === 'compra' ? 800 : 500" [style.color]="ladoRelevante === 'compra' ? '#1e3a8a' : '#6b7280'">Compra</span>
          <span [style.fontWeight]="ladoRelevante === 'compra' ? 800 : 500" [style.color]="ladoRelevante === 'compra' ? '#1e3a8a' : '#6b7280'"
            style="font-family: monospace; text-align: right;">
            {{ binance.compra ? num(binance.compra.promedio) : '—' }}
          </span>
          <span [style.fontWeight]="ladoRelevante === 'venta' ? 800 : 500" [style.color]="ladoRelevante === 'venta' ? '#1e3a8a' : '#6b7280'">Venta</span>
          <span [style.fontWeight]="ladoRelevante === 'venta' ? 800 : 500" [style.color]="ladoRelevante === 'venta' ? '#1e3a8a' : '#6b7280'"
            style="font-family: monospace; text-align: right;">
            {{ binance.venta ? num(binance.venta.promedio) : '—' }}
          </span>
        </div>
        <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px; line-height: 1.35;">
          Promedio de avisos grandes &middot; {{ ladoRelevante === 'compra' ? 'cliente compra USDT' : 'cliente vende USDT' }}
          <span *ngIf="leidoHace" [style.color]="binanceViejo ? '#b45309' : '#9ca3af'" [style.fontWeight]="binanceViejo ? 700 : 400">
            &middot; le&iacute;do {{ leidoHace }}
          </span>
        </p>
      </ng-container>
      <ng-template #binanceNoDisponible>
        <p style="font-size: 0.9rem; font-weight: 700; color: #6b7280;">{{ binanceLeido ? 'Binance no disponible' : 'Leyendo…' }}</p>
        <p *ngIf="binanceLeido" style="font-size: 0.66rem; color: #6b7280; margin-top: 2px;">Se reintenta solo cada minuto.</p>
      </ng-template>
    </div>

    <div *ngIf="!esDistancia" style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 10px 12px;">
      <p style="font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.5px; color: #4b5563; font-weight: 700; margin-bottom: 4px;">Costo</p>
      <p style="font-size: 1.1rem; font-weight: 800; color: #374151; line-height: 1.1;">{{ num(costo) }}</p>
      <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">Promedio de bancos (Binance)</p>
    </div>

    <div *ngIf="!esDistancia" style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 12px; padding: 10px 12px;">
      <p style="font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.5px; color: #c2410c; font-weight: 700; margin-bottom: 4px;">Base Aguacate</p>
      <p style="font-size: 1.1rem; font-weight: 800; color: #9a3412; line-height: 1.1;">{{ num(base) }}</p>
      <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">Tasa actual (tramo chico)</p>
    </div>

    <div *ngIf="!esDistancia" style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 10px 12px;">
      <p style="font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.5px; color: #15803d; font-weight: 700; margin-bottom: 4px;">Rango de tramos</p>
      <ng-container *ngIf="hayTramos; else soloBase">
        <div style="display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 2px 8px; align-items: baseline; font-size: 0.72rem; color: #374151;">
          <span style="min-width: 0;">{{ rotulos.maximo }}</span>
          <span style="font-size: 0.95rem; font-weight: 800; color: #14532d; font-family: monospace; text-align: right;">{{ num(techo) }}</span>
          <span style="min-width: 0;">{{ rotulos.minimo }}</span>
          <span style="font-size: 0.95rem; font-weight: 800; color: #14532d; font-family: monospace; text-align: right;">{{ num(piso) }}</span>
        </div>
        <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">{{ filas.length }} {{ filas.length === 1 ? 'tramo' : 'tramos' }}</p>
      </ng-container>
      <ng-template #soloBase>
        <p style="font-size: 0.9rem; font-weight: 700; color: #4b5563;">Sin tramos</p>
        <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">Todos pagan la base</p>
      </ng-template>
    </div>

    <div style="background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: 12px; padding: 10px 12px;">
      <p style="font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.5px; color: #6d28d9; font-weight: 700; margin-bottom: 4px;">{{ esVesUsdt ? 'USDT → VES' : 'VES → USDT' }}</p>
      <p style="font-size: 1.1rem; font-weight: 800; color: #5b21b6; line-height: 1.1;">{{ num(contraria) }}</p>
      <p style="font-size: 0.66rem; color: #6b7280; margin-top: 4px;">Tasa del otro sentido</p>
    </div>
  </div>

  <!-- Gráfico de niveles -->
  <!-- Bloque de Oscar: solo con el modelo de distancia del API -->
  <app-distancia-bloque *ngIf="esDistancia" [ruta]="direccion" [estado]="tramos" [comisionPct]="comision"
    [activo]="activo" [puedeEditar]="puedeEditar" (guardado)="cargar()">
  </app-distancia-bloque>

  <div *ngIf="!esDistancia && grafico.lineas.length" style="display: flex; gap: 14px; flex-wrap: wrap; padding: 4px 0 18px; max-width: 100%; min-width: 0;">
    <div [style.height.px]="altoGrafico"
      style="position: relative; flex: 1 1 220px; min-width: 0; max-width: 100%; border-left: 1px solid #d1d5db; border-bottom: 1px solid #d1d5db;">
      <div *ngIf="grafico.banda as b" [style.top.%]="b.topPct" [style.height.%]="b.altoPct"
        style="position: absolute; left: 0; right: 0; background: #fff7ed;"></div>
      <div *ngFor="let l of grafico.lineas" [style.top.%]="l.topPct" [style.borderTop]="bordeLinea(l.clave)"
        [title]="l.etiqueta + ': ' + num(l.valor)"
        style="position: absolute; left: 0; right: 0;"></div>
      <ng-container *ngFor="let p of grafico.puntos; let i = index">
        <div [style.top]="'calc(' + p.topPct + '% - 8px)'" [style.left]="'calc(' + p.leftPct + '% - 8px)'"
          [style.background]="colorPunto(p, i)" [style.boxShadow]="'0 0 0 1px ' + colorPunto(p, i)"
          [title]="p.etiqueta + ': ' + num(p.valor)"
          style="position: absolute; width: 16px; height: 16px; border-radius: 50%; border: 3px solid #fff; box-sizing: border-box;"></div>
        <span [style.top]="'calc(' + p.topPct + '% - 22px)'" [style.left]="'calc(' + p.leftPct + '% + 10px)'"
          [style.color]="colorPunto(p, i) === '#15803d' ? '#166534' : '#9a3412'"
          style="position: absolute; font-size: 0.7rem; font-weight: 700; white-space: nowrap;">{{ p.letra }}</span>
      </ng-container>
      <span style="position: absolute; left: 6px; bottom: -18px; font-size: 0.66rem; color: #4b5563;">tramo chico</span>
      <span style="position: absolute; right: 6px; bottom: -18px; font-size: 0.66rem; color: #4b5563;">tramo grande &rarr;</span>
    </div>

    <div [style.height.px]="altoGrafico + 10" style="position: relative; flex: 1 1 150px; max-width: 220px; min-width: 0;">
      <div *ngFor="let e of etiquetas" [style.top.px]="e.topPx"
        style="position: absolute; left: 0; right: 0; display: flex; flex-direction: column; gap: 0;">
        <span [style.color]="colorLinea(e.clave)" style="font-size: 0.68rem; font-weight: 700; line-height: 1.2;">{{ e.etiqueta }}</span>
        <span [style.color]="colorTexto(e.clave)" style="font-size: 0.9rem; font-weight: 800; line-height: 1.2;">{{ num(e.valor) }}</span>
      </div>
    </div>
  </div>

  <!-- Leyenda -->
  <div *ngIf="!esDistancia && grafico.lineas.length" style="display: flex; gap: 6px 14px; flex-wrap: wrap; font-size: 0.68rem; color: #374151;">
    <span style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; border-top: 3px solid #ea580c;"></span>{{ hayTramos ? rotulos.leyendaMaximo : 'Base Aguacate' }}</span>
    <span *ngIf="hayTramos" style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; border-top: 3px solid #15803d;"></span>{{ rotulos.leyendaMinimo }}</span>
    <span *ngIf="precioBinance != null" style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; border-top: 2px dashed #2563eb;"></span>{{ rotulos.leyendaBinance }}</span>
    <span style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; border-top: 2px dashed #6b7280;"></span>Costo: nuestra referencia</span>
    <span *ngIf="contraria != null" style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; border-top: 2px dotted #7c3aed;"></span>Otro sentido</span>
    <span *ngIf="grafico.banda" style="display: flex; align-items: center; gap: 6px;"><span style="width: 20px; height: 10px; background: #fff7ed; border: 1px solid #fed7aa;"></span>Banda de los tramos</span>
  </div>

  <!-- Tabla contra Binance -->
  <div *ngIf="!esDistancia && filas.length" style="overflow-x: auto; max-width: 100%; min-width: 0; border: 1px solid #e5e7eb; border-radius: 12px; -webkit-overflow-scrolling: touch;">
    <table style="width: 100%; border-collapse: collapse; font-size: 0.78rem; min-width: 460px;">
      <thead>
        <tr style="background: #f9fafb; color: #4b5563; text-align: left; font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.4px;">
          <th style="padding: 8px 10px; font-weight: 700;">Tramo</th>
          <th style="padding: 8px 10px; font-weight: 700; text-align: right;">Tasa</th>
          <th style="padding: 8px 10px; font-weight: 700;">vs Binance</th>
          <th style="padding: 8px 10px; font-weight: 700; text-align: right;">Ganancia % sobre costo</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let f of filas" style="border-top: 1px solid #f3f4f6;">
          <td style="padding: 8px 10px; font-weight: 700; color: #374151; white-space: nowrap;">{{ f.etiqueta }}</td>
          <td style="padding: 8px 10px; text-align: right; font-family: monospace; white-space: nowrap;">{{ num(f.tasa) }}</td>
          <td style="padding: 8px 10px; font-weight: 700; white-space: nowrap;"
            [style.color]="f.ganaBinance === true ? '#15803d' : f.ganaBinance === false ? '#b91c1c' : '#6b7280'">
            {{ precioBinance != null ? f.vsBinanceTexto : 'Binance no disponible' }}
          </td>
          <td style="padding: 8px 10px; text-align: right; font-family: monospace; white-space: nowrap;">
            {{ pctSigno(f.margenPct) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p style="font-size: 0.68rem; color: #6b7280; line-height: 1.45;">
    Solo referencia: Binance no mueve ninguna tasa. Se actualiza cada minuto solo con esta sección abierta.
  </p>
</div>
